<template>
  <div>
    <h3>
      Cronometro: {{ tiempo.tiempoFaltanteMinutos + "m " }}
      {{ tiempo.tiempoFaltanteSegundos + "s" }}
    </h3>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      tiempo: {},
      intervalId: null,
      fechaActual: "",
      cabina: [],
      asistencias: [],
    };
  },
  created() {
    this.inicializarCunetaRegresiva();
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    inicializarCunetaRegresiva() {
      this.fechaActual = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        new Date().getHours(),
        new Date().getMinutes() + 1
      );

      this.cuentaRegresiva(this.fechaActual);
    },
    cuentaRegresiva(fechaLimite) {
      this.intervalId = setInterval(() => {
        this.tiempo = this.obtenerFechaFaltante(fechaLimite);

        if (this.tiempo.tiempoFaltante <= 1) {
          clearInterval(this.intervalId);
          this.inicializarCunetaRegresiva();
          this.getAsistenciasProceso();
        }
      }, 1000);
    },
    obtenerFechaFaltante(fechaLimite) {
      let ahora = new Date();
      let tiempoFaltante = (new Date(fechaLimite) - ahora + 1000) / 1000;
      let tiempoFaltanteSegundos = (
        "0" + Math.floor(tiempoFaltante % 60)
      ).slice(-2);
      let tiempoFaltanteMinutos = (
        "0" + Math.floor((tiempoFaltante / 60) % 60)
      ).slice(-2);
      let tiempoFaltanteHoras = (
        "0" + Math.floor((tiempoFaltante / 3600) % 24)
      ).slice(-2);
      let tiempoFaltanteDias = Math.floor(tiempoFaltante / (3600 * 24));
      return {
        tiempoFaltante,
        tiempoFaltanteSegundos,
        tiempoFaltanteMinutos,
        tiempoFaltanteHoras,
        tiempoFaltanteDias,
      };
    },
    getAsistenciasProceso() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.cabina = [];
      me.asistencias = [];
      axios
        .get("api/Cabinas/ListarNoLegales", configuracion)
        .then(function (response) {
          me.cabina = response.data;
          me.verificarAsistencias();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    verificarAsistencias() {
      let me = this;
      me.cabina.map(({ numeroAsistencia, fechaHoraContacto }) => {
        let header = { Authorization: "Bearer " + this.$store.state.token };
        let configuracion = { headers: header };
        if (fechaHoraContacto == null) {
          axios
            .get(
              "api/Bitacoras/MostrarCodigoSeguimiento/" + numeroAsistencia,
              configuracion
            )
            .then(function (response) {
              if (response.data.fechaActualizacion != null) {
                //console.log(response.data.numeroAsistencia, response.data.fechaActualizacion);
                me.darSeguimientoAsistencia(
                  response.data.numeroAsistencia,
                  response.data.fechaActualizacion
                );
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      });
    },
    darSeguimientoAsistencia(numAsistencia, fechaAct) {
      const ahora = Date.now();
      const fechaBitacora = new Date(fechaAct).getTime();

      if (isNaN(fechaBitacora)) {
        console.error("Fecha inválida:", fechaAct);
        return;
      }

      const diferenciaMs = ahora - fechaBitacora;
      const minutosTranscurridos = Math.floor(diferenciaMs / 60000);

      if (minutosTranscurridos >= 10) {
        this.$emit("cronometro", numAsistencia);
      }
    },
  },
};
</script>
